module.exports = __webpack_public_path__ + "580caee08056432018fd786c60862ab6.jpg";